import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  ModalBody,
  ModalFooter,
  Badge,
  UncontrolledTooltip,
  UncontrolledCollapse
} from 'reactstrap';
import classnames from 'classnames';
import CheckBox from '../../../../../../componentes/checkbox/checkbox.component';
import './gerar-blocos.styles.css';
import * as acessos from '../../../../../../acessos.const.util';
import JustificativaReaberturaComponent from './modal/justificativa-reabertura.component';
import CancelamentoComponent from '../../../../../../componentes/cancelamento/cancelamento.component';
import * as DefaultValues from '../../../../../../app/common/util/defaultValues';
import SelectComponent from '@componentes/select/select.component';
import SelectCreatableComponent from '@componentes/select/select-creatable.component';
import ImpressaoReceptaculos from './ImpressaoReceptaculos';
import CheckUrgente from '../../../../detalhesExame/CheckUrgente';
import IntlMessage from '../../../../../../helpers/intlMessage';
import { useIntl } from 'react-intl';

const GeracaoBlocosPage = props =>{
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
  return(
  <React.Fragment>
    <ModalBody className='mv-gerar-blocos'>
      <div className='mv-gerar-blocos-container'>
        <CancelamentoComponent
          title={<IntlMessage id = "dashboards.examDetails.canceledBlock"/>}
          confirmTextLabel={<IntlMessage id = "dashboards.examDetails.canceledBlock"/>}
          isOpen={props.showModalCancelamento}
          toggle={props.toggleModalCancelamento}
          setJustificativa={props.onChangeJustificativaCancelamento}
          justificativaCancelar={props.justificativaCancelamento}
          cancelarEtapa={() => {
            let detalhes = props.detalhesBloco;
            props.apagarCassetesEReordenar(
              detalhes.laudoBloco,
              detalhes.frasco[0].value,
              detalhes.isNovoBloco,
              detalhes.isDoisFrascos,
              detalhes.procedimentoId,
              detalhes.exameId,
              detalhes.tipoId,
              detalhes.nrBloco
            );
          }}
        />
        <JustificativaReaberturaComponent
          show={props.showModalJustificativaReabertura}
          toggle={props.toogleModalJustificativaReabertura}
          justificativa={props.textoJustificativaReabertura}
          change={props.changeTextoJustificativaReabertura}
          reabrir={props.reabrirMapa}
        />
        <ImpressaoReceptaculos
          laudo={props.laudo}
          modalControleReceptaculo={props.modalControleReceptaculo}
        />
        {props.acessoPermitido(props.usuario, acessos.Cassetes) &&
          props.acessoPermitido(props.usuario, acessos.Adicionar) && (
            <Nav tabs>
              {!props.macroscopiaFinalizada && (
                <NavItem>
                  <NavLink
                    className={classnames({ active: props.activeTab === '1' })}
                    onClick={() => {
                      props.toggle('1');
                      props.setInitialStateBlocoCadstro();
                    }}
                  >
                    <IntlMessage id = "dashboards.examDetail.adding"/>
                  </NavLink>
                </NavItem>
              )}
              <NavItem style={{ position: 'relative' }}>
                <NavLink
                  className={classnames({ active: props.activeTab === '2' })}
                  onClick={() => {
                    props.toggle('2');
                  }}
                >
                  <IntlMessage id = "dashboards.examDetail.cassettes"/>
                  <Badge className='total-blocos-existentes'>
                    {props.blocosExistentes.filter(b => !b.cancelado).length +
                      props.blocos.length}
                  </Badge>
                </NavLink>
              </NavItem>
            </Nav>
          )}
        <TabContent activeTab={props.activeTab}>
          {props.acessoPermitido(props.usuario, acessos.Cassetes) &&
            props.acessoPermitido(props.usuario, acessos.Adicionar) &&
            !props.macroscopiaFinalizada && (
              <TabPane tabId='1'>
                <br />
                <form>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label><IntlMessage id = "dashboards.cytology.bottles"/></Label>
                        <SelectComponent
                          isMulti
                          onChange={e => {
                            props.updateValorState('frasco', e);
                          }}
                          options={props.frascos}
                          placeholder={translate("dashboards.examDetails.selectBottle")}
                          value={props.frasco}
                          innerRef={props.frascoRef}
                          disabled={props.mapaFinalizado}
                          tabIndex={props.getTabIndex('frasco')}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup>
                        <Label><IntlMessage id = "dashboards.cytology.numberOfCassetes"/></Label>
                        <Input
                          value={props.numeroBlocos}
                          onChange={e => {
                            props.updateValorState(
                              e.target.name,
                              e.target.value
                            );
                          }}
                          name='numeroBlocos'
                          type='number'
                          min='1'
                          max='10'
                          ref={props.numeroBlocosRef}
                          disabled={props.mapaFinalizado}
                          tabIndex={props.getTabIndex('numeroBlocos')}
                          onKeyPress={ev =>
                            ev.key === 'Enter' &&
                            props.setFocusProximoCampo('numeroBlocos')
                          }
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={3}>
                      <FormGroup>
                        <Label><IntlMessage id = "dashboards.cytology.fragmentsCassette"/></Label>
                        {props.variosFragmentos && (
                          <Input
                            value={'N/D'}
                            name='numeroFragmentos'
                            type='text'
                            disabled={
                              props.variosFragmentos || props.mapaFinalizado
                            }
                          />
                        )}
                        {!props.variosFragmentos && (
                          <Input
                            value={props.numeroFragmentos}
                            onChange={e => {
                              props.updateValorState(
                                e.target.name,
                                e.target.value
                              );
                            }}
                            name='numeroFragmentos'
                            type='number'
                            min='1'
                            max='10'
                            disabled={
                              props.variosFragmentos || props.mapaFinalizado
                            }
                            ref={props.numeroFragmentosRef}
                            tabIndex={props.getTabIndex('numeroFragmentos')}
                            onKeyPress={props.numeroFragmentosKeyPress}
                          />
                        )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup style={{ marginTop: '3px' }}>
                        <CheckBox
                          label={<IntlMessage id = "dashboards.cytology.multipleFragments"/>}
                          name='checkVariosFragmentos'
                          onChange={e => {
                            props.updateValorState(
                              'variosFragmentos',
                              e.target.checked
                            );
                          }}
                          checked={props.variosFragmentos}
                          checkRef={props.checkVariosFragRef}
                          disabled={props.mapaFinalizado}
                          tabIndex={props.getTabIndex('checkVariosFragmentos')}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup style={{ marginTop: '3px' }}>
                        <CheckBox
                          label={<IntlMessage id = "dashboards.cytology.newCuts"/>}
                          name='checkNovosCortes'
                          onChange={e => {
                            props.updateValorState(
                              'novoscortes',
                              e.target.checked
                            );
                          }}
                          checked={props.novoscortes}
                          checkRef={props.checkNovoCorteRef}
                          disabled={props.mapaFinalizado}
                          tabIndex={props.getTabIndex('checkNovosCortes')}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup style={{ marginTop: '3px' }}>
                        <CheckBox
                          label={<IntlMessage id = "dashboards.taskControl.coloring"/>}
                          name='checkColoracao'
                          onChange={e => {
                            props.updateValorState(
                              'coloracao',
                              e.target.checked
                            );
                          }}
                          checked={props.coloracao}
                          checkRef={props.checkColoracaoRef}
                          disabled={props.mapaFinalizado}
                          tabIndex={props.getTabIndex('checkColoracao')}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup style={{ marginTop: '3px' }}>
                        <CheckBox
                          label={<IntlMessage id = "dashboards.examDetail.antigen"/>}
                          name='checkAntigeno'
                          onChange={e => {
                            props.updateValorState(
                              'antigeno',
                              e.target.checked
                            );
                          }}
                          checked={props.antigeno}
                          checkRef={props.checkAntigenoRef}
                          disabled={props.mapaFinalizado}
                          tabIndex={props.getTabIndex('checkAntigeno')}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {
                        <FormGroup
                          style={{
                            display: props.coloracao ? 'block' : 'none'
                          }}
                        >
                          <Label><IntlMessage id = "dashboards.cytology.colors"/></Label>
                          <SelectComponent
                            isMulti
                            name='coloracoesSelecionadas'
                            onChange={e => {
                              props.updateValorState(
                                'coloracoesSelecionadas',
                                e
                              );
                            }}
                            options={props.coloracoes}
                            placeholder={translate("general.requestsPanel.selectColors")}
                            value={props.coloracoesSelecionadas}
                            innerRef={props.coloracaoRef}
                            disabled={props.mapaFinalizado}
                            tabIndex={props.getTabIndex(
                              'coloracoesSelecionadas'
                            )}
                          />
                        </FormGroup>
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      {
                        <FormGroup
                          style={{ display: props.antigeno ? 'block' : 'none' }}
                        >
                          <Label><IntlMessage id = "dashboards.examDetails.antigens"/></Label>
                          <SelectComponent
                            isMulti
                            onChange={e => {
                              props.updateValorState(
                                'antigenosSelecionados',
                                e
                              );
                            }}
                            options={props.antigenos}
                            placeholder={translate("dashboards.cytology.selectAntigens")}
                            value={props.antigenosSelecionados}
                            innerRef={props.antigenoRef}
                            disabled={props.mapaFinalizado}
                            tabIndex={props.getTabIndex(
                              'antigenosSelecionados'
                            )}
                          />
                        </FormGroup>
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label><IntlMessage id = "dashboards.examDetail.Material"/></Label>
                        <SelectCreatableComponent
                          disabled={props.mapaFinalizado}
                          innerRef={props.materialRef}
                          onChange={e => {
                            props.updateValorState('material', e);
                          }}
                          onCreateOption={props.handleCreateSelectCreatable}
                          options={props.materiais}
                          placeholder={translate("dashboards.examDetails.selectMaterial")}
                          label={<IntlMessage id = "dashboards.examDetails.registerNewMaterial"/>}
                          tabIndex={props.getTabIndex('material')}
                          value={props.material}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label><IntlMessage id = "dashboards.cytology.type"/></Label>
                        <SelectComponent
                          onChange={e => {
                            props.updateValorState('tipoBloco', e);
                          }}
                          options={props.tipos}
                          placeholder={translate("general.materialArchiving.selectType")}
                          value={props.tipoBloco}
                          name='tipoBloco'
                          innerRef={props.tipoBlocoRef}
                          tabIndex={props.getTabIndex('tipoBloco')}
                          disabled={props.mapaFinalizado}
                        />
                      </FormGroup>
                    </Col>
                    <Col style={{ paddingTop: '20px' }}>
                      <FormGroup check>
                        <Label check style={{ userSelect: 'none' }}>
                          <Input
                            type='radio'
                            name='sentinela'
                            onClick={() => {
                              props.updateValorSentinela('sentinelaMelanoma');
                            }}
                            checked={props.sentinelaMelanoma}
                            disabled={props.mapaFinalizado}
                            tabIndex='-1'
                          />{' '}
                          <IntlMessage id = "dashboards.cytology.melanomaSentinel"/>
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Label check style={{ userSelect: 'none' }}>
                          <Input
                            type='radio'
                            name='sentinela'
                            onClick={() => {
                              props.updateValorSentinela('sentinelaMama');
                            }}
                            checked={props.sentinelaMama}
                            disabled={props.mapaFinalizado}
                            tabIndex='-1'
                          />{' '}
                          <IntlMessage id = "dashboards.cytology.mamaSentry"/>
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label><IntlMessage id = "dashboards.cytology.macroscopyTechnician"/></Label>
                        <SelectComponent
                          options={props.medicoTecnico}
                          value={props.tecnico}
                          innerRef={props.tecnicoRef}
                          tabIndex={props.getTabIndex('tecnico')}
                          name='tecnico'
                          onChange={e => {
                            props.updateValorState('tecnico', e);
                          }}
                          placeholder={translate("dashboards.examDetails.selectTechnician")}
                          disabled={props.mapaFinalizado}
                        />
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        {/* Adicionar Mapa */}
                        <Label><IntlMessage id = "dashboards.cytology.doctorMacroscopy"/></Label>
                        <SelectComponent
                          options={props.medicoMacro}
                          value={props.medico}
                          innerRef={props.medicoRef}
                          tabIndex={props.getTabIndex('medico')}
                          name='medico'
                          onChange={e => {
                            props.updateValorState('medico', e);
                          }}
                          placeholder={translate("dashboards.examDetails.selectDoctor")}
                          disabled={
                            props.mapaFinalizado ||
                            (!props.acessoPermitido(
                              props.usuario,
                              acessos.AlterarMedicoExecutanteRevisor
                            ) &&
                              props.medico)
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <div className='col-12'>
                      <CheckBox
                        label={<IntlMessage id = "dashboards.examDetails.fullySubmittedExam"/>}
                        onChange={e => {
                          props.marcarMaterialSubmetido(e.target.checked);
                        }}
                        checked={props.materialTotalmenteSubmetido}
                        tabIndex='-1'
                        disabled={props.mapaFinalizado}
                      />
                    </div>
                  </Row>

                  <Row>
                    {!props.materialTotalmenteSubmetido && (
                      <React.Fragment>
                        <Col>
                          <br />
                          <FormGroup>
                            <Label><IntlMessage id = "dashboards.examDetails.typeDiscard"/></Label>
                            <SelectComponent
                              options={props.tipoDescarteOptions}
                              value={props.tipoDescarte}
                              innerRef={props.tipoDescarteRef}
                              tabIndex={props.getTabIndex('tipoDescarte')}
                              name='tipoDescarte'
                              onChange={e => {
                                props.updateValorState('tipoDescarte', e);
                              }}
                              placeholder={translate("dashboards.examDetails.selectTypeDisposal")}
                              disabled={
                                props.mapaFinalizado ||
                                (!props.acessoPermitido(
                                  props.usuario,
                                  acessos.AlterarMedicoExecutanteRevisor
                                ) &&
                                  props.tipoDescarte)
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col>
                          <br />
                          <FormGroup>
                            <Label><IntlMessage id = "dashboards.examDetails.doctorRequestingDisposal"/></Label>
                            <SelectComponent
                              options={props.medicoMacro}
                              value={props.medicoTipoDescarte}
                              innerRef={props.medicoTipoDescarteRef}
                              tabIndex={props.getTabIndex('medicoTipoDescarte')}
                              name='medicoTipoDescarte'
                              onChange={e => {
                                props.updateValorState('medicoTipoDescarte', e);
                              }}
                              placeholder={translate("dashboards.examDetails.selectDoctor")}
                              disabled={
                                !props.tipoDescarte ||
                                props.tipoDescarte.value ===
                                  DefaultValues.tipoDescarteEmum.PADRAO ||
                                props.mapaFinalizado ||
                                (!props.acessoPermitido(
                                  props.usuario,
                                  acessos.AlterarMedicoExecutanteRevisor
                                ) &&
                                  props.tipoDescarte)
                              }
                            />
                          </FormGroup>
                        </Col>
                      </React.Fragment>
                    )}
                  </Row>
                  <hr />
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label><IntlMessage id = "dashboards.examDetail.annotations"/></Label>
                        <Input
                          type='textarea'
                          value={props.anotacoes}
                          ref={props.anotacaoRef}
                          tabIndex={props.getTabIndex('anotacoes')}
                          onChange={e => {
                            props.updateValorState(
                              'anotacoes',
                              e.currentTarget.value
                            );
                          }}
                          onKeyPress={ev =>
                            ev.ctrlKey &&
                            ev.charCode === 13 &&
                            props.gravarBloco()
                          }
                          disabled={props.mapaFinalizado}
                          name='anotacoes'
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </form>
              </TabPane>
            )}
          <TabPane tabId='2'>
            {!props.macroscopiaFinalizada && !props.detalhesBloco && (
              <div className='mv-drag-drop-cassetes'>
                <Row>
                  {props.agrupamento.length !== 0 && (
                    <Col>
                      {props.agrupamento.map((bloco, i) => (
                        <Badge
                          key={i}
                          color='primary'
                          style={{ marginRight: '5px', fontSize: '11px' }}
                        >
                          {bloco.nome}
                        </Badge>
                      ))}
                    </Col>
                  )}
                  {props.agrupamento.length !== 0 && (
                    <Col sm='auto'>
                      <FormGroup style={{ marginBottom: 0 }}>
                        <Input
                          style={{ height: '33px', fontSize: '12px' }}
                          type='text'
                          placeholder='complemento'
                          value={props.complementoAgrupamento}
                          onChange={props.onChangeComplementoAgrupamento}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {props.agrupamento.length !== 0 && (
                    <Col sm='auto'>
                      <Button
                        className='agruparButton'
                        color='primary'
                        onClick={props.agruparCasseteSelecionado}
                      >
                        <IntlMessage id = "dashboards.examDetails.groupSelectedCassettes"/>
                      </Button>
                    </Col>
                  )}
                </Row>
              </div>
            )}
            <div className='inner'>
              <div
                style={{
                  height: props.alturaModal,
                  overflowY: 'scroll',
                  overflowX: 'hidden'
                }}
                className={
                  'item active' + (props.showDetalhesBloco ? ' visible' : '')
                }
              >
                <Row>
                  <Col>
                    {props.blocosExistentes
                      .filter(el => !el.cancelado)
                      .map((bloco, i) => {
                        let coloracoes = props.gerarLabelColoracao(
                          bloco.coloracoesId
                        );
                        let antigenos = props.gerarLabelAntigeno(
                          bloco.antigenosId
                        );
                        let numeroBloco = props.obterNumeroBloco(bloco);

                        return (
                          <Row
                            id={i}
                            name={i}
                            key={bloco.id}
                            className='item-card-bloco-lista'
                          >
                            <Col>
                              <Card>
                                <CardBody>
                                  <div>
                                    <CardTitle>
                                      {`${numeroBloco}`} <IntlMessage id = "dashboards.examDetails.recorded"/>
                                      {bloco.cancelado && (
                                        <span>
                                          <Badge
                                            color='danger'
                                            style={{
                                              marginRight: '5px',
                                              fontSize: '11px'
                                            }}
                                          >
                                            <IntlMessage id = "dashboards.examDetails.canceled"/>
                                          </Badge>
                                        </span>
                                      )}
                                      {bloco.coloracao && (
                                        <span>
                                          <Badge
                                            className='icone-coloracao'
                                            style={{
                                              marginRight: '1px',
                                              fontSize: '11px'
                                            }}
                                          >
                                            <i
                                              id={'coloracao_' + bloco.id}
                                              className='fas fa-eye-dropper'
                                              data-toggle='tooltip'
                                            ></i>
                                          </Badge>
                                          <UncontrolledTooltip
                                            placement='top'
                                            target={'coloracao_' + bloco.id}
                                          >
                                            {coloracoes}
                                          </UncontrolledTooltip>
                                        </span>
                                      )}
                                      {bloco.antigeno && (
                                        <span>
                                          <Badge
                                            className='icone-antigeno'
                                            style={{
                                              marginRight: '5px',
                                              fontSize: '11px'
                                            }}
                                          >
                                            <i
                                              id={'antigeno_' + bloco.id}
                                              className='fas fa-eye-dropper'
                                              data-toggle='tooltip'
                                            ></i>
                                          </Badge>
                                          <UncontrolledTooltip
                                            placement='top'
                                            target={'antigeno_' + bloco.id}
                                          >
                                            {antigenos}
                                          </UncontrolledTooltip>
                                        </span>
                                      )}
                                    </CardTitle>
                                    <CardText>{`${bloco.material}`}</CardText>
                                  </div>
                                  <div>
                                    <div>
                                      <Button
                                        className='editar-cassete'
                                        color='link'
                                        id={'editar_' + bloco.id}
                                        onClick={() => {
                                          props.setVisibilidadeDetalhes(
                                            bloco.id
                                          );
                                        }}
                                      >
                                        <i className='fas fa-edit fa-2x'></i>
                                        <UncontrolledTooltip
                                          placement='top'
                                          target={'editar_' + bloco.id}
                                        >
                                          <IntlMessage id = "dashboards.examDetail.edit"/>
                                        </UncontrolledTooltip>
                                      </Button>
                                      {!props.macroscopiaFinalizada && (
                                        <Button
                                          className='editar-cassete'
                                          color='link'
                                          id={'cancelar_' + bloco.id}
                                          onClick={() =>
                                            props.cancelarBloco(bloco)
                                          }
                                        >
                                          <i className='mv-basico-cancelar  fa-2x'></i>
                                          <UncontrolledTooltip
                                            placement='top'
                                            target={'cancelar_' + bloco.id}
                                          >
                                            <IntlMessage id = "dashboards.examDetails.cancel"/>
                                          </UncontrolledTooltip>
                                        </Button>
                                      )}
                                    </div>
                                    {!bloco.cancelado &&
                                      !props.macroscopiaFinalizada && (
                                        <div>
                                          {props.agrupamento.findIndex(
                                            e => e.id === bloco.id
                                          ) === -1 ? (
                                            <Button
                                              className='editar-cassete'
                                              color='link'
                                              id={'vincular_' + bloco.id}
                                              onClick={() =>
                                                props.adicionarCasseteParaAgrupamento(
                                                  bloco.id,
                                                  bloco.numeroBloco
                                                )
                                              }
                                            >
                                              <i
                                                className='fas fa-link fa-2x'
                                                id={'vincular_' + bloco.id}
                                              >
                                                <UncontrolledTooltip
                                                  placement='top'
                                                  target={
                                                    'vincular_' + bloco.id
                                                  }
                                                >
                                                  <IntlMessage id = "dashboards.examDetail.link"/>
                                                </UncontrolledTooltip>
                                              </i>
                                            </Button>
                                          ) : (
                                            <Button
                                              className='editar-cassete'
                                              color='link'
                                              id={'vincular_' + bloco.id}
                                              onClick={() =>
                                                props.removerCasseteParaAgrupamento(
                                                  bloco.id
                                                )
                                              }
                                            >
                                              <i
                                                className='fas fa-unlink fa-2x'
                                                id={'vincular_' + bloco.id}
                                              >
                                                <UncontrolledTooltip
                                                  placement='top'
                                                  target={
                                                    'vincular_' + bloco.id
                                                  }
                                                >
                                                  <IntlMessage id = "dashboards.examDetail.noLink"/>
                                                </UncontrolledTooltip>
                                              </i>
                                            </Button>
                                          )}
                                        </div>
                                      )}
                                  </div>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        );
                      })}
                    {props.blocos &&
                      props.blocos.length > 0 &&
                      props.blocos.map(bloco => {
                        let reg = new RegExp(`${bloco.nuOrdem}$`);
                        let numeroBloco = props.cassetesNumeracaoContinua
                          ? bloco.numeroBloco
                          : bloco.blocoUnico
                          ? bloco.numeroBloco.replace(reg, '').trimEnd()
                          : bloco.numeroBloco;

                        return (
                          <Row key={bloco.numeroBloco}>
                            <Col>
                              <Card>
                                <CardBody>
                                  <div>
                                    <CardTitle>{`${numeroBloco} (NOVO)`}</CardTitle>
                                    <CardText>{`${bloco.material}`}</CardText>
                                  </div>
                                  <div></div>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        );
                      })}
                    <div>
                      {props.blocosExistentes.filter(el => el.cancelado)
                        .length > 0 && (
                        <Button
                          color='warning'
                          id='toggler'
                          className='cassetes-cancelados-bt'
                        >
                          <IntlMessage id = "dashboards.examDetails.canceledCassettes"/>
                        </Button>
                      )}
                      {props.blocosExistentes.filter(el => el.cancelado)
                        .length > 0 && (
                        <UncontrolledCollapse toggler='#toggler'>
                          {props.blocosExistentes
                            .filter(el => el.cancelado)
                            .map(blococancelado => {
                              let coloracoes = props.gerarLabelColoracao(
                                blococancelado.coloracoesId
                              );
                              let antigenos = props.gerarLabelAntigeno(
                                blococancelado.antigenosId
                              );
                              let numeroBloco = blococancelado.numeroBloco;
                              return (
                                <Card>
                                  <CardBody>
                                    <div>
                                      <CardTitle>
                                        {`${numeroBloco}`}
                                        <span>
                                          <Badge
                                            color='danger'
                                            style={{
                                              marginRight: '5px',
                                              fontSize: '11px'
                                            }}
                                          >
                                            <IntlMessage id = "dashboards.examDetails.canceled"/>
                                          </Badge>
                                        </span>
                                        {blococancelado.coloracao && (
                                          <span>
                                            <Badge
                                              className='icone-coloracao'
                                              style={{
                                                marginRight: '5px',
                                                fontSize: '11px'
                                              }}
                                            >
                                              <i
                                                id={
                                                  'coloracao_' +
                                                  blococancelado.id
                                                }
                                                className='fas fa-eye-dropper'
                                                data-toggle='tooltip'
                                              ></i>
                                              <span><IntlMessage id = "general.requestsPanel.colorations"/></span>
                                            </Badge>
                                            <UncontrolledTooltip
                                              placement='top'
                                              target={
                                                'coloracao_' + blococancelado.id
                                              }
                                            >
                                              {coloracoes}
                                            </UncontrolledTooltip>
                                          </span>
                                        )}
                                        {blococancelado.antigeno && (
                                          <span>
                                            <Badge
                                              className='icone-antigeno'
                                              style={{
                                                marginRight: '5px',
                                                fontSize: '11px'
                                              }}
                                            >
                                              <i
                                                id={
                                                  'antigeno_' +
                                                  blococancelado.id
                                                }
                                                className='fas fa-eye-dropper'
                                                data-toggle='tooltip'
                                              ></i>
                                              <span><IntlMessage id = "general.requestsPanel.colorations"/></span>
                                            </Badge>
                                            <UncontrolledTooltip
                                              placement='top'
                                              target={
                                                'antigeno_' + blococancelado.id
                                              }
                                            >
                                              {antigenos}
                                            </UncontrolledTooltip>
                                          </span>
                                        )}
                                      </CardTitle>
                                      <CardText>{`${blococancelado.material}`}</CardText>
                                    </div>
                                    <div></div>
                                  </CardBody>
                                </Card>
                              );
                            })}
                        </UncontrolledCollapse>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              <div
                // style={{ height: props.alturaModal }}
                className={
                  'item left' + (props.showDetalhesBloco ? ' go-left' : '')
                }
              >
                {props.detalhesBloco !== undefined && (
                  <div className='detalhes-bloco'>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetails.laud"/></Label>
                          <Input
                            type='text'
                            value={props.detalhesBloco.laudo}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.cytology.bottles"/></Label>
                          <SelectComponent
                            disabled
                            isMulti
                            value={props.detalhesBloco.frasco}
                            options={props.frascos}
                            placeholder={translate("dashboards.examDetails.selectBottle")}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetails.exam"/></Label>
                          <Input
                            type='text'
                            value={props.detalhesBloco.nrExame}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetail.blocky"/></Label>
                          <Input
                            type='text'
                            value={props.detalhesBloco.nrBloco}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetails.medicalRecord"/></Label>
                          <Input
                            type='text'
                            value={props.detalhesBloco.prontuario}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetails.datePerformed"/></Label>
                          <Input
                            type='text'
                            value={props.detalhesBloco.dataRealizado}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetails.exam"/></Label>
                          <Input
                            type='text'
                            value={props.detalhesBloco.exame}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.cytology.colors"/></Label>
                          <SelectComponent
                            isMulti
                            id='coloracao-edicao'
                            disabled={!props.modoEdicao}
                            value={props.detalhesBloco.coloracoesId}
                            options={props.coloracoesEdicao}
                            placeholder={translate("general.requestsPanel.selectColors")}
                            onChange={e => {
                              props.updateValorColoracaoDetalhes(e);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetails.antigens"/></Label>
                          <SelectComponent
                            isMulti
                            id='antigeno-edicao'
                            disabled={!props.modoEdicao}
                            value={props.detalhesBloco.antigenosId}
                            options={props.antigenosEdicao}
                            placeholder={translate("dashboards.cytology.selectAntigens")}
                            onChange={e => {
                              props.updateValorAntigenoDetalhes(e);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetail.Material"/></Label>
                          <SelectComponent
                            disabled={!props.modoEdicao}
                            options={props.materiais}
                            placeholder={translate("dashboards.examDetails.selectMaterial")}
                            onChange={e => {
                              props.updateValorDetalhesState([
                                { name: 'nmMaterial', value: e.label },
                                { name: 'materialId', value: e.value }
                              ]);
                            }}
                            value={{
                              label: props.detalhesBloco.nmMaterial,
                              value: props.detalhesBloco.materialId
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.cytology.type"/></Label>
                          <SelectComponent
                            disabled={!props.modoEdicao}
                            options={props.tipos}
                            placeholder={translate("general.materialArchiving.selectType")}
                            onChange={e => {
                              props.updateValorDetalhesState([
                                { name: 'tipoBloco', value: e.label },
                                { name: 'tipoId', value: e.value }
                              ]);
                            }}
                            value={{
                              label: props.detalhesBloco.tipoBloco,
                              value: props.detalhesBloco.tipoId
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <div style={{ paddingTop: '25px' }}>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type='radio'
                                disabled={!props.modoEdicao}
                                name='sentinela2'
                                checked={props.detalhesBloco.sentinelaMelanoma}
                                onChange={e => {
                                  props.updateValorSentinelaModoEdicao(
                                    'sentinelaMelanoma'
                                  );
                                }}
                              />{' '}
                              <IntlMessage id = "dashboards.cytology.melanomaSentinel"/>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type='radio'
                                disabled={!props.modoEdicao}
                                name='sentinela2'
                                checked={props.detalhesBloco.sentinelaMama}
                                onChange={e => {
                                  props.updateValorSentinelaModoEdicao(
                                    'sentinelaMama'
                                  );
                                }}
                              />{' '}
                              <IntlMessage id = "dashboards.cytology.mamaSentry"/>
                            </Label>
                          </FormGroup>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.cytology.macroscopyTechnician"/></Label>
                          <SelectComponent
                            options={props.medicoTecnico}
                            onChange={e => {
                              props.updateValorDetalhesState([
                                { name: 'tecnico', value: e.label },
                                { name: 'tecnicoId', value: e.value }
                              ]);
                            }}
                            placeholder={translate("dashboards.examDetails.selectTechnician")}
                            disabled={!props.modoEdicao}
                            value={{
                              label: props.detalhesBloco.tecnico,
                              value: props.detalhesBloco.tecnicoId
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col>
                        <FormGroup>
                          {/* Editar Mapa */}
                          <Label><IntlMessage id = "dashboards.cytology.doctorMacroscopy"/></Label>
                          <SelectComponent
                            name='medico cassetes'
                            disabled={!props.modoEdicao}
                            options={props.medicoMacro}
                            placeholder={translate("dashboards.examDetails.selectDoctor")}
                            onChange={e => {
                              props.updateValorDetalhesState([
                                { name: 'medico', value: e.label },
                                { name: 'medicoId', value: e.value }
                              ]);
                            }}
                            value={{
                              label: props.detalhesBloco.medico,
                              value: props.detalhesBloco.medicoId
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr />
                    <Row>
                      <div className='col-12'>
                        <CheckBox
                          disabled={!props.modoEdicao}
                          label={<IntlMessage id = "dashboards.examDetails.fullySubmittedExam"/>}
                          onChange={e => {
                            !props.exameEntregue &&
                              props.editarMaterialSubmetido(e);
                          }}
                          checked={
                            props.detalhesBloco &&
                            props.detalhesBloco.materialTotalmenteSubmetido
                          }
                          tabIndex='-1'
                        />
                      </div>
                      {props.detalhesBloco &&
                        !props.detalhesBloco.materialTotalmenteSubmetido && (
                          <React.Fragment>
                            <Col>
                              <br />
                              <FormGroup>
                                <Label><IntlMessage id = "dashboards.examDetails.typeDiscard"/></Label>
                                <SelectComponent
                                  options={props.tipoDescarteOptions}
                                  value={props.tipoDescarte}
                                  innerRef={props.tipoDescarteRef}
                                  tabIndex={props.getTabIndex('tipoDescarte')}
                                  name='tipoDescarte'
                                  onChange={e => {
                                    props.updateValorState('tipoDescarte', e);
                                  }}
                                  placeholder={translate("dashboards.examDetails.selectTypeDisposal")}
                                  disabled={
                                    !props.modoEdicao ||
                                    props.mapaFinalizado ||
                                    (!props.acessoPermitido(
                                      props.usuario,
                                      acessos.AlterarMedicoExecutanteRevisor
                                    ) &&
                                      props.tipoDescarte)
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col>
                              <br />
                              <FormGroup>
                                <Label><IntlMessage id = "dashboards.examDetails.doctorRequestingDisposal"/></Label>
                                <SelectComponent
                                  options={props.medicoMacro}
                                  value={props.medicoTipoDescarte}
                                  innerRef={props.medicoTipoDescarteRef}
                                  tabIndex={props.getTabIndex(
                                    'medicoTipoDescarte'
                                  )}
                                  name='medicoTipoDescarte'
                                  onChange={e => {
                                    props.updateValorState(
                                      'medicoTipoDescarte',
                                      e
                                    );
                                  }}
                                  placeholder={translate("dashboards.examDetails.selectDoctor")}
                                  disabled={
                                    !props.modoEdicao ||
                                    !props.tipoDescarte ||
                                    props.tipoDescarte.value ===
                                      DefaultValues.tipoDescarteEmum.PADRAO ||
                                    props.mapaFinalizado ||
                                    (!props.acessoPermitido(
                                      props.usuario,
                                      acessos.AlterarMedicoExecutanteRevisor
                                    ) &&
                                      props.tipoDescarte)
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </React.Fragment>
                        )}
                    </Row>
                    <hr />
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label><IntlMessage id = "dashboards.examDetail.annotations"/></Label>
                          <Input
                            type='textarea'
                            value={
                              props.detalhesBloco.anotacoes !== null
                                ? props.detalhesBloco.anotacoes
                                : ''
                            }
                            disabled={!props.modoEdicao}
                            onChange={e => {
                              props.updateValorDetalhesState([
                                {
                                  name: 'anotacoes',
                                  value: e.currentTarget.value
                                }
                              ]);
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            </div>
          </TabPane>
        </TabContent>
      </div>
    </ModalBody>
    <ModalFooter className='mv-gerar-blocos-container-footer'>
      <div className='separator'></div>
      <div>
        {/* edição */}
        {props.detalhesBloco !== undefined &&
          !props.detalhesBloco.blocoCancelado &&
          props.showDetalhesBloco &&
          props.activeTab === '2' && (
            <Button onClick={props.setVisibilidadeDetalhes} color='secondary'>
              <IntlMessage id = "dashboards.examDetails.backToList"/>
            </Button>
          )}
        <Button
          className='modalComponente-fechar'
          color='secondary'
          onClick={props.fecharModal}
          tabIndex='-1'
        >
          <IntlMessage id = "dashboards.examDetails.cancel"/>
        </Button>

        {!props.macroscopiaFinalizada &&
          props.detalhesBloco !== undefined &&
          !props.detalhesBloco.blocoCancelado &&
          !props.modoEdicao &&
          props.showDetalhesBloco &&
          props.activeTab === '2' && (
            <Button
              style={{ color: '#fff' }}
              color='warning'
              onClick={props.alternarModoEdicao}
              disabled={props.mapaFinalizado}
            >
              <IntlMessage id = "dashboards.examDetails.enableEditing"/>
            </Button>
          )}
        {!props.macroscopiaFinalizada &&
          props.detalhesBloco !== undefined &&
          !props.detalhesBloco.blocoCancelado &&
          props.modoEdicao &&
          props.showDetalhesBloco &&
          props.activeTab === '2' && (
            <Button
              color='primary'
              onClick={() => {
                props.updateDetalhes(
                  props.detalhesBloco.laudoBloco,
                  props.detalhesBloco.procedimentoId,
                  props.detalhesBloco.exameId,
                  props.detalhesBloco.tipoId
                );
              }}
            >
              <IntlMessage id = "dashboards.examDetails.saveChange"/>
            </Button>
          )}
        {/* fim edição */}

        {/* cadastro */}
        {!props.macroscopiaFinalizada && props.activeTab === '1' && (
          <Button
            color='primary'
            className='adicionar-cassete'
            onClick={props.gravarBloco}
            name='adicionarCassete'
            tabIndex={props.getTabIndex('adicionarCassete')}
            disabled={props.habilitarBotaoAdicionar()}
          >
            <IntlMessage id = "dashboards.examDetails.addCassete"/>
          </Button>
        )}
        {/* fim cadastro */}
      </div>
    </ModalFooter>
    <div className='mv-gerar-blocos-container-finalizar-mapa'>
      <div className='checkbox-urgente'>
        <CheckUrgente
          justificativaFixa={
            <IntlMessage id = "dashboards.examDetails.urgentUserExam"/>
          }
        />
        {/* <CheckBox
          label='Urgente'
          onChange={e => {
            !props.exameEntregue &&
              props.marcarExameComoUrgente(e.target.checked);
          }}
          checked={props.urgente}
          tabIndex='-1'
          disabled={props.mapaFinalizado}
        /> */}
      </div>
      <div className='imprimir-receptaculo'>
        {props.blocosExistentes.filter(b => !b.cancelado).length > 0 && (
          <Button color='link' onClick={props.toogleModalControleReceptaculo}>
            <i className='mv-basico-imprimir'></i> 
            <IntlMessage id = "dashboards.examDetails.printReceptacleControl"/>
          </Button>
        )}

        {!props.mapaFinalizado && (
          <Button
            className='button-finalizar-mapa'
            color='primary'
            onClick={props.finalizarMapa}
            tabIndex='-1'
            disabled={
              props.blocosExistentes.length === 0
                ? true
                : props.blocosExistentes.filter(b => !b.cancelado).length === 0
            }
          >
            <IntlMessage id = "dashboards.examDetails.finishMacroscopicMap"/>
          </Button>
        )}

        {props.mapaFinalizado && (
          <Button
            className='button-finalizar-mapa'
            color='danger'
            onClick={props.toogleModalJustificativaReabertura}
            tabIndex='-1'
          >
            <IntlMessage id = "dashboards.examDetails.reopenMacroscopicMap"/>
          </Button>
        )}
      </div>
    </div>
  </React.Fragment>
);

}

export default GeracaoBlocosPage;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/blocos/gerar-blocos.page.js